import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { CardComponent } from './card.component'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { TranslateModule } from '@ngx-translate/core'
import { ContentEditableModule } from '@containers/i18n/content-editable/content-editable.module'

@NgModule({
  declarations: [CardComponent],
  imports: [CommonModule, FormsModule, TranslateModule, ContentEditableModule],
  exports: [CardComponent],
})
export class CardModule {}
